import React from 'react';
import { LandingHeader } from './LandingHeader';
import { LandingHero } from './LandingHero';
import { LandingProblem } from './LandingProblem';
import { LandingHowItWorks } from './LandingHowItWorks';
import { LandingModules } from './LandingModules';
import { LandingIntegrations } from './LandingIntegrations';
import { LandingDifference } from './LandingDifference';
import { LandingStats } from './LandingStats';
import { LandingCTA } from './LandingCTA';
import { LandingFooter } from './LandingFooter';

// Landing pública de producto. 100% estática: sin llamadas a /api/*, sin sesión, sin datos reales.
const LandingPage = () => (
  <div className="min-h-screen bg-white" data-testid="landing-page">
    <LandingHeader />
    <LandingHero />
    <LandingProblem />
    <LandingHowItWorks />
    <LandingModules />
    <LandingIntegrations />
    <LandingDifference />
    <LandingStats />
    <LandingCTA />
    <LandingFooter />
  </div>
);

export default LandingPage;
